<div class="relative">
  <input
    class="form-input w-full rounded-md border border-neutral-200 px-3 py-2 text-sm"
    type="text"
    [value]="term()"
    [placeholder]="'protocols.edit.searchPlaceholder' | translate"
    (input)="onInput($event)"
    (focus)="results().length && open.set(true)"
  />

  @if (open()) {
    <div class="bg-neutral-0 absolute top-full right-0 left-0 z-10 mt-1 max-h-72 overflow-auto rounded-md border border-neutral-200 shadow-lg">
      @if (loading() && !results().length) {
        <p class="px-3 py-2 text-sm text-neutral-400">{{ "protocols.edit.searching" | translate }}</p>
      } @else if (!results().length) {
        <p class="px-3 py-2 text-sm text-neutral-400">{{ "protocols.edit.noResults" | translate }}</p>
      } @else {
        @for (item of results(); track item.code) {
          <button
            type="button"
            class="flex w-full flex-col items-start gap-0.5 border-b border-neutral-100 px-3 py-2 text-left last:border-b-0 hover:bg-neutral-50"
            (click)="choose(item)"
          >
            <span class="text-xs font-medium text-neutral-500">{{ item.code }}</span>
            <span class="text-sm text-neutral-700">{{ item.nameUa || item.nameEn }}</span>
          </button>
        }
        @if (continuationToken()) {
          <button
            type="button"
            class="text-primary-500 w-full px-3 py-2 text-center text-sm hover:bg-neutral-50"
            (click)="loadMore()"
          >
            {{ (loading() ? "protocols.edit.searching" : "protocols.edit.loadMore") | translate }}
          </button>
        }
      }
    </div>
    <div
      class="fixed inset-0 z-0"
      (click)="close()"
    ></div>
  }
</div>
